// ================================tab on product page====================
$(document).ready(function () {
 // Initially set active tab to null
    let activeTab = null;

    // Loop through each tab header and check corresponding content
    $(".head").each(function() {
      var tabId = $(this).attr("data-tab");
      var content = $("#" + tabId).html().trim();

      if (content !== "" && activeTab === null) {
        activeTab = $(this); // Set the first non-empty tab as active
      }
    });

    // If an active tab is found, activate it
    if (activeTab !== null) {
      activeTab.addClass("active");
      $("#" + activeTab.attr("data-tab")).addClass("active").show();
    }

    // Handle click events
    $(".head").click(function() {
      var tabId = $(this).attr("data-tab");

      // Hide all tab contents and remove active class from all heads
      $(".content-wrapper").hide().removeClass("active");
      $(".head").removeClass("active");

      // Show the selected tab and add the active class to the clicked head
      $("#" + tabId).show().addClass("active");
      $(this).addClass("active");
    });
  // ==============================popup on product page variant size=================
  var modal = document.getElementById("myModal");
  var btn = document.getElementById("myBtn");
  var span = document.getElementsByClassName("close")[0];

  btn.onclick = function () {
    modal.style.display = "block";
    $("#myModal").addClass("block");
    if ($("#myModal").hasClass("block")) {
      $("body").css("overflow", "hidden");
    } else {
      $("body").css("overflow", "auto");
    }
  };

  span.onclick = function () {
    modal.style.display = "none";
    $("body").css("overflow", "auto");
  };

  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.display = "none";
      $("body").css("overflow", "auto");
    }
  };

  // =====================================================read more read less on product tab======================
     // function AddReadMore() {
     //          var wordLmt = 50; // Limit for words
     //          var readMoreTxt = " ...Read more";
     //          var readLessTxt = " Read less";

     //          $(".product-description .add-read-more").each(function () {
     //              var $this = $(this);
     //              var content = $this.html();
     //              var plainText = $this.html(); // Extract plain text

     //              var words = plainText.split(/\s+/); // Split the text by spaces

     //              if (words.length > wordLmt) {
     //                  var firstSet = words.slice(0, wordLmt).join(' ');
     //                  var secondHalf = words.slice(wordLmt).join(' ');

     //                  // Create a div to wrap the first part
     //                  var firstPartHtml = "<div class='first-part'>" + firstSet + "</div>";

     //                  // Rebuild the hidden part with original HTML to preserve formatting
     //                  var moreHtml = content.replace(plainText, secondHalf);

     //                  // Construct the new content with Read More and Read Less
     //                  var newContent =
     //                      firstPartHtml +
     //                      "<span class='more-text' style='display:none;'>" + moreHtml + "</span>" +
     //                      "<span class='read-more' style='cursor:pointer;color:#01165d;font-weight:600;' title='Click to Show More'>" + readMoreTxt + "</span>" +
     //                      "<span class='read-less' style='display:none;cursor:pointer;color:#01165d;font-weight:600;' title='Click to Show Less'>" + readLessTxt + "</span>";

     //                  $this.html(newContent); // Update the element with new content
     //              }
     //          });

     //          // Event binding for Read More
     //          $(document).on("click", ".read-more", function () {
     //              var $parent = $(this).parent();
     //              $parent.find(".more-text").show();  // Show hidden content
     //              $parent.find(".read-more").hide();  // Hide "Read more" button
     //              $parent.find(".read-less").show();  // Show "Read less" button
     //              // $parent.find(".first-part").hide(); // Hide the first set of text
     //          });

     //          // Event binding for Read Less
     //          $(document).on("click", ".read-less", function () {
     //              var $parent = $(this).parent();
     //              $parent.find(".more-text").hide();  // Hide extended content
     //              $parent.find(".read-more").show();  // Show "Read more" button
     //              $parent.find(".read-less").hide();  // Hide "Read less" button
     //              // $parent.find(".first-part").show(); // Show the first set of text again
     //          });
     //      }

     //      AddReadMore();

});




  // function AddReadMore() {
  //   var wordLmt = 50; // Limit for words
  //   var readMoreTxt = " ...Read more";
  //   var readLessTxt = " Read less";

  //   $(".product-description .add-read-more").each(function () {
  //     var content = $(this).html();
  //     var plainText = $(this).text(); // Only extract the text content

  //     var words = plainText.split(/\s+/); // Split the text by spaces
      
  //     if (words.length > wordLmt) {
  //       var firstSet = words.slice(0, wordLmt).join(' ');
  //       var secondHalf = plainText.split(/\s+/).slice(wordLmt).join(' ');

  //       var moreHtml = content.replace(plainText, secondHalf); // Retain the original HTML for the hidden part
        
  //       var newContent = firstSet + 
  //         "<span class='more-text' style='display:none;'>" + moreHtml + "</span>" + 
  //         "<span class='read-more' style='cursor:pointer;color:#01165d;font-weight:600;' title='Click to Show More'>" + readMoreTxt + "</span>" +
  //         "<span class='read-less' style='display:none;cursor:pointer;color:#01165d;font-weight:600;' title='Click to Show Less'>" + readLessTxt + "</span>";
        
  //       $(this).html(newContent); // Update the element with new content
  //     }
  //   });

  //   // Read More and Read Less Click Event binding
  //   $(document).on("click", ".read-more", function () {
  //     $(this).siblings(".more-text").show();  // Show hidden content
  //     $(this).hide();  // Hide "read more"
  //     $(this).siblings(".read-less").show();  // Show "read less"
  //   });

  //   $(document).on("click", ".read-less", function () {
  //     $(this).siblings(".more-text").hide();  // Hide extended content
  //     $(this).hide();  // Hide "read less"
  //     $(this).siblings(".read-more").show();  // Show "read more"
  //   });
  // }

  // AddReadMore();



  // jQuery(document).ready(function($) {
  //       $('.readmore').insertAfter( '.product-description' );
  //       $('.readmore').click(function (event) {
  //         event.preventDefault();
  //         var description = document.querySelector('.product-description');
  //         console.log(description.style.height)
  //         if (description.style.height === ''){
  //           description.style.height = 'auto';
  //         } else if (description.style.height === 'auto'){
  //           description.style.height = '';
  //         }
  //         else{
  //           description.style.height = '92px';
  //         }

  //         $(this).text($(this).text() == 'Read less...' ? 'Read more...' : 'Read less...');
  //       });
  //     });


